<template>
    <el-dialog title="字段隐显规则" width="40%" append-to-body :close-on-click-modal="false" :visible.sync="visible">
        <div class="noDataBox p_b2" v-if="!dataList.length">
            <img src="@/assets/img/noData.png" class="noData">
            <div class="m_b2">暂无设置字段隐显规则</div>
            <el-button type="primary" @click="addEdit(null, 'add')" size="small">添加隐显规则</el-button>
        </div>
        <div class="p_t1" v-else v-loading="loading">
            <el-button type="primary" @click="addEdit(null, 'add')" size="small">添加隐显规则</el-button>
            <div class="m_t1 cardItemBox">
                <el-card class="item m_b1" v-for="(item, index) in dataList" :key="index">
                    <div class="flex_b_c">
                        <div class="cardInfo">
                            <div class="flex_l_t m_b1">
                                <el-link class="tit" type="primary" :underline="false">当</el-link>
                                <div class="flex_1">
                                    <div class="txt" v-for="(v, i) in item.metadataBasicDataShowRuleDetailList" :key="i">
                                        <span v-if="i > 0">{{item.ruleWhere == '0' ? '且':'或'}}</span>【{{v.basicRename}}】{{v.basicCondition}}“<span v-for="(r, k) in v.basicRanges" :key="k">{{r.basicRange}}<span v-if="k < v.basicRanges.length-1">、</span></span>”<span v-if="i == item.metadataBasicDataShowRuleDetailList.length-1">时</span>
                                    </div>
                                </div>
                            </div>
                            <div class="flex_l_t">
                                <el-link class="tit" type="primary" :underline="false">显示</el-link>
                                <span class="txt">当前字段</span>
                            </div>
                        </div>
                        <div>
                            <el-link icon="el-icon-edit" class="m_l1" type="primary" :underline="false" @click="addEdit(item, 'edit')"></el-link>
                            <el-link icon="el-icon-delete" class="m_l1" type="danger" :underline="false" @click="del(item.id)"></el-link>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
        <HidingRuleForm ref="hidingRuleForm" @refreshDataList="refreshList()"></HidingRuleForm>
    </el-dialog>
</template>

<script>
    import HidingRuleForm from './hidingRuleForm'

    export default {
        components: {HidingRuleForm},
        data() {
            return {
                visible: false,
                loading: false,
                metadataInfo: {},
                dataList: [],
            }
        },
        methods: {
            init(row) {
                this.dataList = []
                this.metadataInfo = row
                this.visible = true
                this.refreshList()
            },
            refreshList() {
                this.loading = true
                this.$axios(this.api.metadata.selectMetadataBasicDataShowRuleList, {basicDataDetailId: this.metadataInfo.id, basicDataId: this.metadataInfo.basicDataId}).then(data => {
                    if (data && data.status) {
                        this.dataList = data.data
                    }
                    this.loading = false
                })
            },
            // 编辑
            addEdit(item, method) {
                this.$refs.hidingRuleForm.init(item, method, this.metadataInfo)
            },
            // 删除
            del(id) {
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true
                    this.$axios(this.api.metadata.showRuleSaveRemoveById + '/' + id, {}, 'delete').then(data => {
                        if (data && data.status) {
                            this.$message.success(data.msg)
                            this.refreshList()
                        } else {
                            this.$message.error(data.msg)
                        }
                        this.loading = false
                    })
                })
            },
        },
    }
</script>

<style scoped>
    .cardItemBox {
        height: calc(100vh - 208px);
        overflow-y: auto;
    }
    .el-card {
        height: auto !important;
    }
    .cardInfo {
        width: 85%;
    }
    .tit {
        width: 62px;
        text-align: right;
        display: inline-block !important;
        font-size: 12px;
    }
    .txt {
        width: 70%;
        vertical-align: middle;
        margin-left: 10px;
        font-size: 12px;
    }
</style>
